import { render, staticRenderFns } from "./ArticleMove.vue?vue&type=template&id=c05c5f68&"
import script from "./ArticleMove.vue?vue&type=script&lang=ts&"
export * from "./ArticleMove.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports